module.exports = {
    CATEGORIES_COLORS: {
        bar: '#ff9e67',
        cafe: '#ff9e67',
        restaurant: '#ff9e67',

        airport: '#0fbdff',
        bus_station: '#0fbdff',
        subway_station: '#0fbdff',
        train_station: '#0fbdff',
        taxi_stand: '#0fbdff',
        transit_station: '#0fbdff',

        atm: '#8f9ce2',
        car_rental: '#8f9ce2',
        parking: '#8f9ce2',

        shopping_mall: '#4a96f3',

        museum: '#12b5c7',
        art_gallery: '#12b5c7',
        aquarium: '#12b5c7',
        amusement_park: '#12b5c7',
        zoo: '#12b5c7',
        casino: '#12b5c7',
        stadium: '#12b5c7',

        park: '#4db546',

        church: '#7b9eb1',
        city_hall: '#7b9eb1'
    }
}



// WEBPACK FOOTER //
// ./src/globals/categoriesColors.js